const tripTypeConstants = {
    "SCHEDULE_ACTIVE": 1,
    "ON_DEMAND_ACTIVE": 2,
    "BOTH_ACTIVE": 3,
    "NONE_ACTIVE" : 0
};
Object.freeze(tripTypeConstants);
export default tripTypeConstants;